import { Injectable } from "@angular/core";
import { Adapter } from "../Interfaces/adapter";

export class Policy {
    constructor(
        public policiesTable: string ,
        public policyID: number,
        public policyNumber: string,
        public title: string,
        public fileName: string,
        public categoryID: number,
        public category: string,
        public active: string,
        public addingPolicyStatus: string,
    ){ }
}

@Injectable({
    providedIn: 'root'
})

export class PolicyAdapter implements Adapter<Policy> {
    adapt(item: any): Policy {
        return new (
            item.policiesTable,
            item.policyID,
            item.policyNumber,
            item.title,
            item.fileName,
            item.categoryID,
            item.category,
            item.active,
            item.addingPolicyStatus
        );
    }
}